<template>
  <div class="SiteNav" ref="SiteNav">
    <nav>
      <div class="wrapper">
        <router-link :to="{ name: 'Digital' }" :class="[currentPage.includes('digital') ? activeClass: '' ,'digital']" v-show="!navScrolled">Digital</router-link>
        <router-link :to="{ name: 'Other' }" :class="[currentPage.includes('other') ? activeClass: '' ,'other']" v-show="!navScrolled">Other</router-link>
        <div class="head" role="button" tabindex="0" @click="handleHomeLink">
          <transition name="vFade">
            <img v-if="!navOpen" src="/assets/ui/mike-head.svg" alt="Mike Cassie">
            <div v-else class="navToggle"><span></span><span></span></div>
          </transition>
        </div>
        <router-link :to="{ name: 'About' }" :class="[currentPage.includes('about') ? activeClass: '' ,'about']" v-show="!navScrolled">About</router-link>
        <router-link :to="{ name: 'Contact' }" :class="[currentPage.includes('contact') ? activeClass: '' ,'contact']" v-show="!navScrolled">Contact</router-link>
      </div>
    </nav>
    <transition name="vFade">
      <div class="scrolledMenu" ref="scrolledMenu" v-if="navOpen" @click="closeMenu">
        <nav>
          <router-link :to="{ name: 'Home' }" :class="currentPage == '/' ? activeClass: ''">Home</router-link>
          <router-link :to="{ name: 'Digital' }" :class="[currentPage.includes('digital') ? activeClass: '' ,'digital']">Digital</router-link>
          <router-link :to="{ name: 'Other' }" :class="[currentPage.includes('other') ? activeClass: '' ,'other']">Other</router-link>
          <router-link :to="{ name: 'About' }" :class="[currentPage.includes('about') ? activeClass: '' ,'about']">About</router-link>
          <router-link :to="{ name: 'Contact' }" :class="[currentPage.includes('contact') ? activeClass: '' ,'contact']">Contact</router-link>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'SiteNav',
  data() {
    return {
      navScrolled: false,
      navOpen: false,
      scrollTimer: null,
      activeClass: 'activeLink'
    }
  },
  computed: {
    currentPage() {
      return this.$route.path
    }
  },
  created () {
    this.scrollThrottle = throttle(this.navScroll, 300)
    this.resizeThrottle = throttle(this.windowResize, 500)
    window.addEventListener('scroll', this.scrollThrottle)
    window.addEventListener('resize', this.resizeThrottle)
  },
  mounted() {
    // set up for mobile
    this.$refs.SiteNav.classList.add('scrollOverride')
    let windowWidth = window.innerWidth
    if (windowWidth < 640) {
      this.$refs.SiteNav.classList.add('scrolled')
      this.$refs.SiteNav.classList.add('mobileStart')
      this.navScrolled = true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollThrottle)
    window.removeEventListener('resize', this.windowResize)
  },
  methods: {
    navScroll() {
      let currentScroll = window.pageYOffset
      let windowWidth = window.innerWidth
      if (windowWidth >= 640) {
        if (currentScroll > 40 && this.scrollTimer === null) {
          this.$refs.SiteNav.classList.add('scrolled')
          this.scrollTimer = setTimeout(() => {
            this.navScrolled = true
          }, 800);
        } else if (currentScroll < 40) {
          clearTimeout(this.scrollTimer)
          this.scrollTimer = null
          this.navScrolled = false
          this.navOpen = false
          setTimeout(() => {
            this.$refs.SiteNav.classList.remove('scrolled')
          }, 50);
        }
      }
      if (currentScroll < 40) {
        this.$refs.SiteNav.classList.add('scrollOverride')
      } else {
        this.$refs.SiteNav.classList.remove('scrollOverride')
      }
    },
    windowResize() {
      let currentScroll = window.pageYOffset
      let windowWidth = window.innerWidth
      if (windowWidth < 640) {
        this.$refs.SiteNav.classList.add('scrolled')
        this.navScrolled = true
      }
      if (windowWidth >= 640 && currentScroll < 40) {
        this.$refs.SiteNav.classList.remove('scrolled')
        this.navScrolled = false
      }
      this.$refs.SiteNav.classList.remove('mobileStart')
    },
    handleHomeLink() {
      if (this.navScrolled) {
        if (this.navOpen == true) {
          this.$refs.scrolledMenu.classList.add('closing')
        }
        this.navOpen = !this.navOpen
      } else {
        this.$router.push({ name: 'Home' })
      }
      setTimeout(() => {
        document.activeElement.blur()
      }, 300);
    },
    closeMenu() {
      this.$refs.scrolledMenu.classList.add('closing')
      this.navOpen = false
      document.activeElement.blur()
    }
  }
}
</script>

<style scoped lang="scss">
.SiteNav {
  position: relative;

  & > nav {
    position: fixed;
    top: 20px;
    left: 0;
    right: 0;
    z-index: 50;

    & .wrapper {
      @include siteWrapper;
      position: relative;
      display: flex;
      justify-content: space-around;

      & .head {
        height: 90px;
        width: 90px;
        border-radius: 45px;
        border: 2px solid transparent;
        position: relative;
        transform-origin: center;
        z-index: 10;
        // will-change: scale;
        cursor: pointer;
        transition: all 300ms;

        &:focus {
          outline: none;
        }
        &:hover {
          // border: 1px solid #000;
          transform: scale(1.1);
        }

        & img {
          position: absolute;
          z-index: 5;
          height: 70px;
          top: 10px;
          left: 23px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          // will-change: height;
          transform-origin: center;
          transition: all 300ms;
        }

        & .navToggle {
          height: 100%;
          width: 100%;
          position: relative;
          z-index: 5;

          & span {
            display: block;
            width: 60px;
            height: 4px;
            background: #000;
            position: absolute;
            left: 14px;
            top: 43px;
            transform-origin: center;

            &:first-child {
              transform: rotate(45deg);
              animation: closeOne 500ms 1;
            }
            &:last-child {
              transform: rotate(135deg);
              animation: closeTwo 500ms 1;
            }
          }
          @keyframes closeOne {
            from {transform: rotate(45deg) scaleX(0);}
            to {transform: rotate(45deg) scaleX(1);}
          }
          @keyframes closeTwo {
            from {transform: rotate(135deg) scaleX(0);}
            to {transform: rotate(135deg) scaleX(1);}
          }
        }
      }


      & > a {
        @include fontBodyHead;
        font-size: 13px;
        text-transform: uppercase;
        display: block;
        position: absolute;
        z-index: 5;
        top: 50%;
        transform: translateY(-50%);
        text-decoration: none;
        opacity: 1;
        transition: all 800ms;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 1px;
          width: 1%;
          height: 1px;
          background: transparent;
          transition: all 200ms;
        }

        &.activeLink, &:hover {
          color: #000;

          &::after {
            width: 100%;
            background: #000;
          }
        }
        &.digital {
          left: 0;
        }
        &.other {
          left: 100px;
        }
        &.about {
          right: 100px;
        }
        &.contact {
          right: 0;
        }
      }
    }
  }

  & .scrolledMenu {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 40;
    background: rgba(255,255,255,0.9);
    text-align: center;

    & > nav {
      position: absolute;
      left: 50%;
      top: 30px;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;

      & > a {
        color: #000;
        @include fontBodyHead;
        text-decoration: none;
        font-size: 22px;
        text-transform: uppercase;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 1%;
          height: 1px;
          background: #fff;
          transition: all 200ms;
        }

        &.activeLink, &:hover {
          color: #000;

          &::after {
            width: 100%;
            background: #000;
          }
        }
        &:nth-child(1) {
          animation: link1 500ms 1 forwards;
        }
        &:nth-child(2) {
          animation: link2 500ms 1 forwards;
        }
        &:nth-child(3) {
          animation: link3 500ms 1 forwards;
        }
        &:nth-child(4) {
          animation: link4 500ms 1 forwards;
        }
        &:nth-child(5) {
          animation: link5 500ms 1 forwards;
        }
        @keyframes link1 {
          from {top: 0;}
          to {top: 80px;}
        }
        @keyframes link2 {
          from {top: 0;}
          to {top: 150px;}
        }
        @keyframes link3 {
          from {top: 0;}
          to {top: 220px;}
        }
        @keyframes link4 {
          from {top: 0;}
          to {top: 290px;}
        }
        @keyframes link5 {
          from {top: 0;}
          to {top: 360px;}
        }
      }
    }
    &.closing {
      & > nav {
        & > a {
          &:nth-child(1) {
            animation: linkOff1 500ms 1 forwards;
          }
          &:nth-child(2) {
            animation: linkOff2 500ms 1 forwards;
          }
          &:nth-child(3) {
            animation: linkOff3 500ms 1 forwards;
          }
          &:nth-child(4) {
            animation: linkOff4 500ms 1 forwards;
          }
          &:nth-child(5) {
            animation: linkOff5 500ms 1 forwards;
          }
          @keyframes linkOff1 {
            from {top: 80px;}
            to {top: 0;}
          }
          @keyframes linkOff2 {
            from {top: 150px;}
            to {top: 0;}
          }
          @keyframes linkOff3 {
            from {top: 220px;}
            to {top: 0;}
          }
          @keyframes linkOff4 {
            from {top: 290px;}
            to {top: 0;}
          }
          @keyframes linkOff5 {
            from {top: 360px;}
            to {top: 0;}
          }
        }
      }
    }
  }

  // scrolled version
  &.scrolled {
    top: 10px;

    & > nav {
      top: 10px;

      & .wrapper {

        & .head {
          transform: scale(0.57);
          // height: 60px;
          // width: 60px;
          // border-radius: 30px;
          border: 2px solid #000;
          // background: rgba(255,255,255,0.9);
          background: #fff;
          // box-shadow: 0 0 0 1px #000;
          // transition: all 300ms;

          // &::before {
          //   content: '';
          //   display: block;
          //   height: calc(100% - 2px);
          //   width: calc(100% - 2px);
          //   border-radius: 50%;
          //   background: #fff;
          //   border: 2px solid #000;
          //   position: absolute;
          //   top: 50%;
          //   left: 50%;
          //   transform: translate(-50%, -50%);
          //   z-index: 4;
          // }
          // &::after {
          //   content: '';
          //   display: block;
          //   height: calc(100% - 4px);
          //   width: calc(100% - 4px);
          //   border-radius: 50%;
          //   background: #000;
          //   position: absolute;
          //   top: 2px;
          //   left: 2px;
          //   // transform: translate(-50%, -50%);
          //   transform-origin: center;
          //   z-index: 3;
          //   transition: all 300ms;
          // }


          & img {
            // top: -4px;
            // left: 9px;
            // height: 40px;
            // transform: scale(0.57);
          }
          &:hover {
            transform: scale(0.7);
            // box-shadow: 0 0 0 3px #000;
            &::after {
              transform: scale(1.2);
            }
          }
        }

        & > a {
          opacity: 0;

          &.digital {
            left: 50%;
          }
          &.other {
            left: 50%;
          }
          &.about {
            right: 50%;
          }
          &.contact {
            right: 50%;
          }
        }
      }
    }
  }
  // scroll override
  &.scrollOverride {
    & > nav {
      & .wrapper {
        & .head {
          background: transparent;
        }
      }
    }
  }

  // mobile loaded
  &.mobileStart {
    & > nav {

      & .wrapper {

        & .head {
          // animation: headLoad 900ms 2000ms 3;

          &::after {
            animation: headPsuedo 1400ms 2000ms 4;
          }
        }
        @keyframes headLoad {
          0% {box-shadow: 0 0 0 1px #000;}
          50% {box-shadow: 0 0 0 4px #000;}
          100% {box-shadow: 0 0 0 1px #000;}
        }
        @keyframes headPsuedo {
          0% {transform: scale(1); background: #999;}
          100% {transform: scale(1.5); background: transparent;}
        }
      }
    }
  }

  @media screen and (max-width: $breakSmall) {

    & > nav {

      & .wrapper {

        & > a {
          font-size: 12px;

          &.digital {
            left: 0;
          }
          &.other {
            left: 70px;
          }
          &.about {
            right: 75px;
          }
          &.contact {
            right: 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: $breakHandsetLandscape) {
    & > nav {

      & .wrapper {

        & > a {
          font-size: 11px;

          &::after {
            bottom: 5px;
          }

          &.other {
            left: 65px;
          }
          &.about {
            right: 70px;
          }
        }
      }
    }
  }
}
</style>
